"use client";

import React, { useState } from "react";
import { getSavedQrFormat, saveQrFormat, type QrFormat } from "../utils/qrFormat";

const formats: { label: string; value: QrFormat }[] = [
  { label: "Solo folio", value: "folio" },
  { label: "JSON (folio y nombre)", value: "json" },
];

type Props = {
  className?: string;
};

const SelectQrFormat: React.FC<Props> = ({ className = "" }) => {
  const [value, setValue] = useState<QrFormat>(() => getSavedQrFormat());

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const v: QrFormat = e.target.value === "json" ? "json" : "folio";
    setValue(v);
    saveQrFormat(v);
  };

  return (
    <div>
      <label htmlFor="qr-format" className="block text-sm font-medium text-gray-700 py-2">
        Contenido del QR del gafete
      </label>
      <select
        name="qr-format"
        id="qr-format"
        value={value}
        onChange={handleChange}
        className={`w-60 bg-white border-2 border-gray-300 text-gray-800 rounded-xl px-3 py-2
                    focus:bg-blue-50 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20
                    outline-none transition-all duration-300 ${className}`}
        aria-label="Contenido del QR del gafete"
      >
        {formats.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectQrFormat;
